import { render, staticRenderFns } from "./UpdateSamSupport.vue?vue&type=template&id=514c4bca"
import script from "./UpdateSamSupport.vue?vue&type=script&lang=js"
export * from "./UpdateSamSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports